import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	ModalComponent,
	TileComponent,
	IconComponent,
	InfoGroupComponent,
	DividerComponent,
} from '@tecalisdev/infinity';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'app-modal-irpf-help',
	templateUrl: './modal-irpf-help.component.html',
	styleUrls: ['./modal-irpf-help.component.scss'],
	imports: [ModalComponent, TranslatePipe, TileComponent, IconComponent, InfoGroupComponent, DividerComponent],
})
export class ModalIrpfHelpComponent {
	@Input() isVisible: boolean = false;
	@Input() url: string;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
